module.exports = __webpack_public_path__ + "img/ys-1.ebb004cc.svg";